import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import Browser from '@wetransfer/concorde-browser';

import I18n from '@module/i18n';
import VideoIllustration from '@component/illustration/video-illustration';
import Button from '@component/form/element/button';
import { TransferActions } from '@app/transfer-bundle/store/actions';

export const Password = ({ transferId, secret, recipient, verifyPassword }) => {
  const [password, setPassword] = useState('');
  const [pending, setPending] = useState(false);

  const onChange = (event) => {
    setPassword(event.target.value);
  };

  const onButtonClick = async () => {
    setPending(true);

    try {
      await verifyPassword(transferId, secret, recipient, password);
    } finally {
      setPending(false);
    }
  };

  const onKeyDown = (event) => {
    if (password && event.key === 'Enter') {
      onButtonClick();
    }
  };

  const active = !pending && !!password;
  const transferButtonClassName = classnames('transfer__button', {
    'transfer__button--inactive': !active,
  });

  return (
    <div className="transfer__window downloader">
      <div className="transfer__contents">
        <div className="downloader__password">
          <VideoIllustration
            src="transfer_window/transfer_password"
            type="transfer-password"
          />
          <h2>{I18n.t('transfer.password.title')}</h2>
          <p>{I18n.t('transfer.password.text')}</p>
          <input
            type="password"
            className="transfer__textfield"
            onChange={onChange}
            onKeyDown={onKeyDown}
            placeholder={I18n.t('transfer.options.password')}
            value={password}
          />
          {Browser.isMobile ? (
            <Button
              text={I18n.t('transfer.buttons.continue')}
              active={active}
              onClick={onButtonClick}
            />
          ) : null}
        </div>
      </div>
      {Browser.isMobile ? null : (
        <div className="transfer__footer">
          <button className={transferButtonClassName} onClick={onButtonClick}>
            {I18n.t('transfer.buttons.continue')}
          </button>
        </div>
      )}
    </div>
  );
};

Password.propTypes = {
  secret: PropTypes.string,
  recipient: PropTypes.string,
  transferId: PropTypes.string,
  verifyPassword: PropTypes.func,
};

const mapDispatchToProps = { verifyPassword: TransferActions.verifyPassword };

export default connect(
  null,
  mapDispatchToProps
)(Password);
